import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/svenData";

// Cross-route nav: pages navigate directly; anchors scroll (via home if needed).
export const useGoTo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (item) => {
    if (item.type === "page") {
      navigate(item.to);
    } else if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: item.id } });
    } else {
      scrollToId(item.id);
    }
  };
};
